import { useQuery } from '@tanstack/react-query';
import { apiClient } from '@copro/api';
import type { DocumentIndexingStats, DocumentIndexingStatus } from '../types/documentIndexing';
import { keys } from './keys';

export function computeDocumentIndexingStats(
  rows: Array<{ status: string; extracted_at: string | null }>
): DocumentIndexingStats {
  let done = 0;
  let pending = 0;
  let errorCount = 0;
  let unsupported = 0;
  let latestExtractedAt: string | null = null;

  for (const row of rows) {
    const status = row.status as DocumentIndexingStatus;
    if (status === 'done') done += 1;
    else if (status === 'pending') pending += 1;
    else if (status === 'error') errorCount += 1;
    else if (status === 'unsupported') unsupported += 1;

    if (row.extracted_at) {
      if (!latestExtractedAt || new Date(row.extracted_at) > new Date(latestExtractedAt)) {
        latestExtractedAt = row.extracted_at;
      }
    }
  }

  return {
    total: rows.length,
    done,
    pending,
    error: errorCount,
    unsupported,
    lastExtractedAt: latestExtractedAt,
  };
}

async function fetchDocumentIndexingStats(spaceId: string): Promise<DocumentIndexingStats> {
  const { data, error } = await apiClient
    .from('document_contents')
    .select('status, extracted_at')
    .eq('space_id', spaceId);

  if (error) {
    throw error;
  }

  return computeDocumentIndexingStats(data ?? []);
}


export function useGetDocumentIndexingStats(spaceId?: string | null) {
  return useQuery({
    queryKey: keys.getDocumentIndexingStats(spaceId ?? ''),
    queryFn: () => fetchDocumentIndexingStats(spaceId!),
    enabled: !!spaceId,
  });
}
